import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

/**
 * Controls css styling for this component using js to css
 */
let css = {
  root: {
    textAlign: "center",
    maxHeight: 80,
    height: 80,
    backgroundColor: "#f8f9fa",
    overflow: "hidden",
    borderBottom: "1px solid lightgray"
  },
  container: {
    padding: "1rem",
    height: 50,
    width: "75%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "auto"
  },
  textbox: {
    flex: "3 1 auto",
    backgroundColor: "#e9ecef",
    "&:focus": {
      borderColor: "#1971c2"
    }
  },
  button: {
    height: 40,
    color: "#fff",
    backgroundColor: "#1971c2",
    width: "9rem",
    marginLeft: "1rem",
    alignSelf: "center"
  }
};

/**
 * Component that accepts user input of Well-Known Text
 *
 * @component
 * @example
 * <WellKnownTextInput />
 *
 */
export default function WellKnownTextInput(props) {
  // const classes = useStyles();
  const wktLink =
    "https://www.vertica.com/docs/9.2.x/HTML/Content/Authoring/AnalyzingData/Geospatial/Spatial_Definitions/WellknownTextWKT.htm";
  
  const [wktStr, setWktStr] = React.useState("");
  const handleWktChange = event => {
    setWktStr(event.target.value);
  }

  const handleDrawWktClick = event => {
    window.drawControl.addShapeFromWKT(wktStr);
    window.top.postMessage("setWkt " + wktStr, "*");
  }

  const trimWkt = wkt =>
    wkt.replace(/\d+\.\d+/g, match => Number(match).toFixed(props.accuracy));

  // Listen for message from Nomenclature
  window.addEventListener("message", function(e) {
    if (typeof e.data == "string") {
      if (e.data.includes("drawWkt")) {

        // Remove "drawWkt " instruction and trim decimals
        let receivedWKT = trimWkt(e.data.replace(/^drawWkt\s/i, ""));

        try {
          window.drawControl.wkt.read(receivedWKT);
          // Clear all and draw received WKT
          window.drawControl.clearFeatures();
          window.drawControl.addShapeFromWKT(receivedWKT);

          // Set new WKT
          setWktStr(receivedWKT);
        } catch(e) {
          // console.log("invalid");
        }

      } else if (e.data.includes("setWkt")) {

        // Remove "setWkt instruction", trim decimals, and set WKT
        setWktStr(trimWkt(e.data.replace(/^setWkt\s/i, "")));
      }
    }
  }, false);

  return (
    <div style={css.root}>
        <div style={css.container}>
          <TextField
            sx={css.textbox}
            variant="outlined"
            label="Enter WKT String"
            InputLabelProps={{
              shrink: true
            }}
            id="wktTextBox"
            name="fname"
            type="text"
            autoComplete="off"
            value={wktStr}
            onChange={handleWktChange}
          />
          <Button
            variant="contained"
            sx={css.button}
            id="wktButton"
            onClick={handleDrawWktClick}>
            Draw On Map
          </Button>
        </div>
    </div>
  );
}
